'use strict';

var _ = require('lodash');
var KpiRibbonService = function KpiRibbonService($filter, distanceUnitService, userPreferencesService) {
  var distanceUnitSuffix = distanceUnitService.getSuffix();
  var kpiConfig = require('../config/kpiRibbonConfig');
  var rmNumberFormat = $filter('rmNumberFormat');
  var modeToWorkflow = {
    'market': 'marketAnalysis',
    'service': 'marketAnalysis',
    'cabin': 'flightAnalysis',
    'cabinSeasonalAverage': 'flightAnalysis',
    'cabinPostDeparture': 'flightAnalysisPostDeparture'
  };
  function formatMetric(metric, value, type) {
    value = _.isNumber(value) ? value : metric.value;
    type = type || metric.type;
    return rmNumberFormat(value, type);
  }
  function generateItems(mode, data) {
    var configs = kpiConfig[mode];
    var workflow = modeToWorkflow[mode];
    var percentageConfig = userPreferencesService.getUserSettingComponent('showKPIIndicatorAsPercentage', workflow);
    //go through all items configs and generate KPI items
    return configs.map(function (config) {
      //init item
      var item = {
        //adjust item name
        name: config.distanceUnitSuffix ? config.name + distanceUnitSuffix : config.name,
        //adjust tooltip
        simplifiedTooltip: config.simplifiedTooltip
      };

      //adjust item metrics based on config metrics
      item.metrics = config.metrics.map(function (metric) {
        metric = _.omit(metric, 'lastYearValue', 'diff');
        //get mapped values
        var values = metric.fields.map(function (field) {
          return data[field];
        });
        metric.value = _.round(values[0], metric.precision);
        metric.lastYearValue = _.round(values[1], metric.precision);
        // if lastYearValue is NaN, indicator calc not needed
        if (_.isNaN(metric.lastYearValue)) {
          return _.omit(metric, 'fields', 'precision');
        }
        var diff = 0;
        metric.showLastYearValue = true;
        if (percentageConfig) {
          metric.indicator = _.get(metric, 'indicatorAsPercentage');
        }
        switch (_.get(metric, 'indicator.diff')) {
          //show indicator as absolute diff
          case 'absolute':
            diff = metric.value - metric.lastYearValue;
            metric.displayValue = Math.abs(diff);

            // if less then threshold do nothing
            if (metric.lastYearValue > metric.indicator.threshold) {
              metric.diff = diff > 0 ? 1 : diff < 0 ? -1 : 0;
            }

            // no data case
            if (_.isNaN(diff)) {
              metric.diff = 0;
            }
            break;
          //show indicator as percentage diff
          case 'percentage':
            diff = (metric.value - metric.lastYearValue) * 100 / metric.lastYearValue;
            metric.displayValue = Math.abs(diff);
            // if less then threshold do nothing
            if (metric.lastYearValue > metric.indicator.threshold) {
              metric.diff = diff > 0 ? 1 : diff < 0 ? -1 : 0;
            }

            // no data case or infinity diff
            if (_.isNaN(diff) || !isFinite(diff)) {
              metric.diff = 0;
            }
            break;
          // show indicator as it is with values comparison
          default:
            diff = metric.value - metric.lastYearValue;
            metric.diff = diff > 0 ? 1 : diff < 0 ? -1 : 0;
            metric.displayValue = metric.lastYearValue;
            if (_.isNaN(diff)) {
              metric.diff = 0;
            }
            break;
        }
        return _.omit(metric, 'fields', 'precision');
      });
      return item;
    });
  }
  return {
    generateItems: generateItems,
    formatMetric: formatMetric
  };
};
KpiRibbonService.$inject = ['$filter', 'DistanceUnitService', 'UserPreferencesService'];
module.exports = KpiRibbonService;